import React, { memo, useRef } from "react";
import { Handle, Position } from "react-flow-renderer";

import {
  Status,
  TaskContainer,
  TaskLabel,
  TaskPeriod,
  TaskData,
  Stats,
  ImageContainer,
  Footer,
  Header,
  StyledTippy,
} from "./styles.js";

import moment from "moment";
import Clip from "../../../assets/icons/clip";
import Chat from "../../../assets/icons/Chat";
import Check from "../../../assets/icons/Check";
import Flag from "../../../assets/icons/Flag";
import { useGantt } from "../../../hooks/useGantt.js";
import { useSelector } from "react-redux";
import { getFileLog } from "../../../state/files/slice";
import { getChatLog } from "../../../state/chat/selector";
import { TippyContent } from "./TippyContent";
import { DateTime } from "luxon";
const getProgress = (data, job) => {
  const status = data.status;

  if (!job) {
    return { message: "Fora do Escopo", status: "none" };
  }

  if (status === "done" || status === "doing") {
    const baseTime = moment(data.startedAt)
      .add(data.expiration.number, "hours")
      .format();

    if (status === "done") {
      const finishedAt = moment(data.finishedAt);
      const diff = finishedAt.diff(baseTime, "hours");

      if (diff < 0) {
        return { message: "Concluído", status: "done" };
      } else {
        return { message: "Concluído com atraso", status: "doneLate" };
      }
    } else {
      const nowLocal = moment().utcOffset(-180);
      const diff = nowLocal.diff(baseTime, "hours");
      if (diff < 0) {
        return { message: "Em execução", status: "doing" };
      } else {
        return {
          message: "Atrasado em ~" + Math.round(diff / 24) + " dias",
          status: "late",
        };
      }
    }
  } else {
    return { message: "Pendente", status: "pending" };
  }
};

const ActiveTaskNode = ({
  data,
  id,
  targetPosition = Position.Left,
  sourcePosition = Position.Right,
}) => {
  const { jobs } = useGantt();

  const job = jobs.find((item) => item.id === id);
  const expectedDate = DateTime.fromJSDate(job?.end)
    .setLocale("pt-BR")
    .toFormat("dd LLL yy");
  const currentJob = job ? true : false;

  const { message, status } = getProgress(data, job);

  const fileLog = useSelector((state) => state.fileLog);
  const thisNode = useSelector((state) =>
    state.activedFlows.pane.flow.elements.find((item) => item.id === id)
  );

  const chat = useSelector((state) => getChatLog(state, thisNode?._id));
  const getTaskLog = getFileLog(fileLog, thisNode?._id);
  const filesLen = getTaskLog?.files.length;

  const subtasks = data.subtasks;
  const allSubtasks = subtasks.length;
  const doneSubtasks = subtasks.filter((item) => item.checked).length;
  const taskRef = useRef();
  return (
    <>
      <TaskContainer
        ref={taskRef}
        status={status}
        className="flow_elements_node"
        data-id={id}
        style={{ cursor: "pointer", opacity: currentJob ? "1" : "0.6" }}
      >
        <Header>
          <Status status={status} accountable={data.accountable}>
            <span>{message}</span>
          </Status>

          <ImageContainer src={data.accountable?.avatarURL} />
        </Header>
        <TaskLabel accountable={data.accountable} status={status}>
          {data.label}
        </TaskLabel>
        <Footer accountable={data.accountable}>
          <TaskPeriod job={currentJob} status={status}>
            {currentJob ? (
              <>
                <Flag />
                <span>{expectedDate}</span>
              </>
            ) : (
              "--"
            )}
          </TaskPeriod>
          <TaskData>
            <Stats
              style={{ visibility: filesLen ? "visible" : "hidden" }}
              expiredTask={data.expired}
              status={status}
            >
              <Clip />
              <span>{filesLen}</span>
            </Stats>
            <Stats
              status={status}
              accountable={data.accountable}
              style={{
                marginLeft: "14px",
                visibility: chat.length ? "visible" : "hidden",
              }}
            >
              <Chat />
              <span>{chat.length}</span>
            </Stats>
            <Stats
              status={status}
              accountable={data.accountable}
              style={{ marginLeft: "14px" }}
            >
              <Check />
              <span>{doneSubtasks + "/" + allSubtasks}</span>
            </Stats>
          </TaskData>
        </Footer>

        <Handle
          type="target"
          id="c"
          position={targetPosition}
          style={{ width: "8px", height: "8px" }}
        />
        <Handle
          type="source"
          position={sourcePosition}
          id="a"
          style={{ width: "8px", height: "8px" }}
        />
      </TaskContainer>

      {job ? (
        <StyledTippy
          content={<TippyContent job={job} />}
          reference={taskRef}
          duration={200}
          placement="right-start"
          arrow={true}
          delay={[850, 0]}
        />
      ) : null}
    </>
  );
};

export default memo(ActiveTaskNode);
